import {argusRegExp} from "@/utils/reg-exp";
import {message} from "antd";
import axios, {AxiosPromise} from "axios";
import {logout} from "@/libs/auth-session";
import {defaultHeaders, TBaseResponse} from "@/api/sora";

// const uat = false;
// export const SH_BASE_API = uat ? "http://47.98.35.49:83/api/" : 'https://yunhuiju.pro/api';
// export const BASE_API = uat ?'http://47.98.35.49:83/sora-center':'https://yunhuiju.pro/sora-center';

// export const SH_BASE_API = 'https://yunhuiju.pro/api';
export const BASE_API = 'https://yunhuiju.pro/sora-center';
export const BASE_STABILITY_API = 'https://yunhuiju.pro/stability';

export const SH_BASE_API = BASE_API;

export async function responseHandler(res: any, resolve: (val?: any) => any, reject: (val?: any) => any) {
    if (res.data?.code === 200 || res.data?.status === 200) {
        return resolve(res);
    } else if (res.data?.code === 401 || res.data?.status === 401) {
        await logout().then(() => {
            // message.warning('用户信息已过期，请重新登录');
            // setTimeout(() => {
            //     window.location.href = window.location.origin + '/login';
            // }, 2000);
        });
        return reject();
    } else if (res.data?.code === 404 || res.data?.status === 404) {
        message.error(res.data?.message || '未找到资源');
        return reject(res);
    } else if (!res.data?.code && !res.data?.status) {
        return resolve(res);
    } else {
        return reject(res);
    }
}


export interface TUserEquity {
    video_balance: number;
    is_vip_month_v24_03_04?: boolean;
    vip_month_v24_03_04_end_time?: number;

    is_vip_week_v24_03_04?: boolean;
    vip_week_v24_03_04_end_time?: number;
    has_temp_message?: boolean;

    share_code: string
}

export function getUserEquity(): AxiosPromise<TBaseResponse<TUserEquity>> {
    return new Promise((resolve, reject) => {
        axios.get<TBaseResponse<TUserEquity>>(BASE_API + "/user/equity", {
            params: {
                ...defaultHeaders()
            }
        }).then(async res => {
            return responseHandler(res, resolve, reject);
        }).catch((e: any) => {
            if (e?.data?.status === 404) {
                logout();
            }
            reject(e);
        });
    });
}

export interface TUserMessage {
    user_id: number,
    temp_message: {
        message: string,
        create_time: string,
    }[],
}


export function getUserTempMessage(): AxiosPromise<TBaseResponse<TUserMessage>> {
    return new Promise((resolve, reject) => {
        axios.get<{ data: { has_temp_message: boolean } }>(BASE_API + "/user/temp-message", {
            params: {
                ...defaultHeaders()
            }
        }).then(async res => {
            return responseHandler(res, resolve, reject);
        }).catch((e: any) => {
            reject(e);
        });
    });
}

export function clearUserTempMessage(): AxiosPromise<TBaseResponse<null>> {
    return new Promise((resolve, reject) => {
        axios.post<TBaseResponse<null>>(BASE_API + "/user/clear-temp-message", {}, {
            params: {
                ...defaultHeaders()
            }
        }).then(async res => {
            return responseHandler(res, resolve, reject);
        }).catch((e: any) => {
            reject(e);
        });
    });

}


export function loginByPhone(props: {
    phone: string;
    code: string;
    phone_type: string;
    register_share_code?: string;
}): AxiosPromise<{ data: { token: string, uid: string, isShareCodeRegister?: boolean }, message: '' }> {
    const {phone,phone_type, register_share_code, code} = props;

    return new Promise((resolve, reject) => {
        axios.post<{
            code: number,
            data: null,
            msg: string
        }>(BASE_API + "/login/phone", {
            phone,
            code,
            register_share_code,
            phone_type:phone_type.replace('+','')
        }).then(async res => {
            return responseHandler(res, resolve, reject);
        }).catch((e: any) => {
            if (e.response?.data?.code === 401) {
                message.error('请重新登录');
            }
            reject(e);
        });
    });
}


// 获取用于验证是否是机器人图片，用户将图片转正后发给后端验证
export function getVerifyRobatImg(phone: string,phone_type:string): AxiosPromise<{ data: string }> {
    return new Promise((resolve, reject) => {
        axios.get(SH_BASE_API + "/captcha/get_captcha/" + phone,{
            params:{
                phone_type
            }
        }).then(async res => {
            return responseHandler(res, resolve, reject);
        }).catch((e: any) => {
            reject(e);
        });
    });
}

export function getVerifyCode(
    phonePrefix: "+86" | "+852",
    phone: string,
    angle: number
) {
    if (
        !(phonePrefix === "+86"
            ? argusRegExp.chinaPhone.test(phone)
            : argusRegExp.chinaHongKongPhone.test(phone))
    ) {
        message.warning("请输入正确的手机号");
        return Promise.reject("error phone");
    }

    const reqData = {
        account: phone,
        phone_type: phonePrefix.replace("+", ""),
        angle // 图片验证的旋转角
    };

    return new Promise((resolve, reject) => {
        axios
            .post<{
                code: number;
                data: string;
                msg: string;
            }>(SH_BASE_API + "/captcha/send_code", reqData)
            .then((res) => {
                if (res.data.code !== 200) {
                    message.error("获取验证码失败，请调整角度后再试");
                    reject("failed");
                } else {
                    message.success("短信验证码已发送");
                    resolve(res);
                }
            })
            .catch((e) => {
                message.error("获取验证码失败，请检查网络或联系客服");
                reject(e);
            });
    });
}